module.exports = __webpack_public_path__ + "img/b98abc1e5e2b67b0b0484a93cdcdffa8.98a3495c.jpg";